import axios from "./axios";
import { ApiResponse } from "../types/express-data.type";
import {
  IncomeExpenseReport,
  IncomeExpenseReportLevel,
  IncomeExpenseReportParams,
} from "../types/income-expense-report.type";

const INCOME_EXPENSE_REPORT_PATH = "/income-expense-report";

/**
 * The screen always reads route-days: the branch and route rows, the drill-down and the profit
 * sparklines are summed from them, so drilling never asks the server again.
 */
const ROUTE_DAY_LEVEL: IncomeExpenseReportLevel = "day";

/** รับจ่าย S1. `signal` aborts a request a newer filter has replaced. */
export const getIncomeExpenseReport = (
  params: IncomeExpenseReportParams,
  signal: AbortSignal,
) => {
  const search = new URLSearchParams({
    start: params.start,
    end: params.end,
    mode: params.mode,
    level: ROUTE_DAY_LEVEL,
  });
  params.branchCodes.forEach((branchCode) => search.append("branch", branchCode));
  return axios.get<ApiResponse<IncomeExpenseReport>>(
    `${INCOME_EXPENSE_REPORT_PATH}?${search.toString()}`,
    { signal },
  );
};
